import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import Toggle from 'react-toggle'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import NumericInput from 'react-numeric-input'
import Select from 'react-select'
import moment from 'moment'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import GreyHeader from '../../component/dump/menuComponents/GreyHeader'
import CompanyExternalIntegrations from './CompanyExternalIntegrations'
import CustomAPN from './CustomAPN'
import CustomButton from '../../component/CustomButton'
import CalendarDropdown from "../../component/smart/CalendarDropdown";

import { geotabAuthentication } from '../../component/helpers/helperGeotab'
import { isInternalUser, timezoneDBOptions, allCountriesOptions, statesOptions } from '../../component/helpers/constants'
import { errorDetection } from '../../component/helpers/helperErrors'
import { getCompanyById, updateCompany, deleteCompany, getCompaniesList, disableCompany } from '../../action/CompaniesActions'
import { checkImportStatus } from '../../action/AccountActions'
import { getCompanyGeotabData, deleteGeotabCompany } from '../../action/GeotabActions'
import { getUsers, getAssignedUsersOfCompany } from '../../action/ClientActions'
import { getDevicesDriverID, toggleDevicesDriverID } from '../../action/DeviceActions'

import '../../component/dump/menuComponents/menuComponents.sass'
import EventVideoExpiration from '../../component/common/EventVideoExpiration'
import ModalDelete from '../../component/smart/modals/ModalDelete'
import { deleteExternalRelation } from "../../action/CustomActions";

const CompanyEditContainer = (props) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'companiesPage.companyEditContainer' });
	const { location, user, toggleLoader } = props;
	const userRole = user.roles[0];

	const [showZonesConfirmation, setShowZonesConfirmation] = useState(false) // FWSD-8571
	const [state, setState] = useState({
		trialAvailableUsers: [],
		company: {},
		data: {
			data_limit: '',
			billing_date: '',
			partner_company: '',
			driver_recognition: 'manual',
		},
		modal: {
			show: false,
			content: '',
			error: false,
		},
		errMessage: {
			company_name: '',
			company_city: '',
			company_state: '',
			company_zipcode: '',
			company_address: '',
			company_country: '',
			billing_date: '',
			active: '',
			partner_company: '',
			company_type: '',
			user_login: '',
			user_password: '',
			fleet_token_r1: '',
			data_limit: '',
			geotab_email: '',
			industry_type: '',
			company_phone_number: '',
		},
		initialCompany: location.state.company,
		toggle_password: true,
		log_in: {
			user_login: '',
			user_password: '',
			fleet_token_r1: '',
		},
		status: false,

		geotabCredentials: {
			email: '',
			password: '',
		},
		allow_edit_company: true,
	})
	const { company, initialCompany, data, errMessage, companies, trialAvailableUsers, modal, geotabCredentials /*, webfleetCredentials*/ } = state

	useEffect(() => {
		getData();
		if (userRole === 'system_admin') importStatus();
	}, []);

	useEffect(() => {
		return () => {
			localStorage.removeItem("edit_company_data");
		}
	}, [location]);

	// FWSD-6885
	const hideProvisionBtns = !isInternalUser(userRole) && state.company && (state.company.id === 2522 || state.company.created_by_company_id === 2522)
	const externalType = _.upperFirst(company.geotab_database ? 'Geotab' : company.external_srv_type || company.external_srv_pending || '')

	const getData = async () => {
		if (location) {
			toggleLoader(true);
			const companyType = 'PARTNER';
			let companyData = localStorage.getItem("edit_company_data");
			companyData ? companyData = JSON.parse(companyData) : companyData = { company_name: null, partner_company: null };
			const params = {
				name: companyData.company_name || state.initialCompany.company_name,
				partner: companyData.partner_company || state.initialCompany.partner_company,
				roles: 'sales_demo',
			};

			const requestArray = [];
			requestArray.push(getCompanyById(userRole, state.initialCompany.id, 'zone_activation'));
			requestArray.push(getCompaniesList(userRole, companyType));
			requestArray.push(getUsers(userRole, params));
			['system_admin', 'customer_service'].includes(userRole) && requestArray.push(getAssignedUsersOfCompany({ userRole, partnerName: params.partner, companyName: params.name }));
			await Promise.all(requestArray)
				.then((res) => {
					toggleLoader(false);

					const companyData = res[0].data.response.company;
					const companies = _.sortBy(res[1].data.response['companies list'], num => num.toLowerCase());
					if (state.data.company_type !== 'WCS') {
						_.remove(companies, (el) => { return el === 'Rosco Vision WCS' })
					}
					let resUsers = [];
					let assignedUsers;
					if (res[3]) assignedUsers = res[3].data.response;

					// Gets Geotab database data when company has geotab provision
					if (companyData.geotab_database) {
						const data = {
							company_name: companyData.company_name,
							partner_name: companyData.partner_company,
							user_role: userRole,
							company_id: companyData.id,
							get_p: true,
						}
						getCompanyGeotabData(data)
							.then(res => {
								setState(prevState => ({ ...prevState, geotabCredentials: res.data.response }));
							})
							.catch(err => {
								console.log(err)
							})
					}

					if (companyData.trial_subscribers) {
						resUsers = companyData.trial_subscribers.split(',').map(item => ({ value: item, label: item }))
					}

					resUsers = res[2].data.response.users.map(item => ({ value: item.email, label: item.email }));

					const sales = _.find(assignedUsers, ['role', 'sales_demo']);
					if (sales) {
						resUsers = sales.users.map((item) => ({ value: item, label: item }))
					}

					setState(prevState => ({
						...prevState,
						company: JSON.parse(JSON.stringify(companyData)),
						initialCompany: JSON.parse(JSON.stringify(companyData)),
						data: companyData,
						companies: companies,
						trialAvailableUsers: _.uniqBy([...state.trialAvailableUsers, ...resUsers], 'value')
					}));
				})
				.catch((error) => {
					toggleLoader(false);
					console.error('Promise.all error: ', error.response, error)
					toastr.error(t('issueGettingCompany'))
				});
		}
	}

	const goBack = () => {
		if (location && location.state && location.state.type) {
			switch (location.state.type) {
				case 'reports':
					navigate('/reports');
					break;
				default:
					navigate('/company')
					break;
			}
		}
		else {
			navigate('/company')
		}
	}

	const sendForm = (e) => {
		e.preventDefault();
		saveCompanyUpdates();
	}

	const saveCompanyUpdates = async (e) => {
		const { user, addCompany, delCompany, editCompany, editCompanyCollection } = props
		const { data, company, initialCompany } = state

		const changedData = _.reduce(_.keys(data), (result, key) => {
			if (!Object.prototype.hasOwnProperty.call(company, key) || !_.isEqual(company[key], data[key])) {
				result[key] = data[key]
			}
			return result;
		}, {});
		if (_.isEmpty(changedData)) {
			toastr.warning('', t('companyNoChanges'))
			return
		}
		if (changedData.dms_notifs_cutoff === null) changedData.dms_notifs_cutoff = 0;

		const sendData = {
			company: initialCompany,
			data: changedData,
		}

		const error = checkForm(changedData)
		if (!error) {
			toggleLoader(true)
			// If was changed the "Enable Driver ID" from "cardreader" to any other then we have to send the Peripherals.CardReader.Enabled=false to all of devices where it is enabled
			if (initialCompany.driver_recognition === 'cardreader' && changedData.driver_recognition !== 'cardreader' && initialCompany.active) {
				// Get list of devices with enabled Peripherals.CardReader.Enabled
				const devicesDriverID = await getDevicesDriverID(initialCompany.id)
					.then((res) => {
						return res
					})
					.catch((error) => {
						let errDescription = t('unableUpdateCompany')
						if (error.response?.data?.body) {
							errDescription = errorDetection(error.response.data.body) || error.response.data.body
						}
						toastr.error(errDescription)
					})
				const selectedVehicleIds = devicesDriverID.data.response.devices.map(vehicle => vehicle.device_id)
				// If exist devices with Peripherals.CardReader.Enabled=true then we disable the DriverId notifications
				if (selectedVehicleIds.length) {
					toggleDevicesDriverID({ enabled: false, devices: selectedVehicleIds.join(',') }, initialCompany.id)
				}
			}

			updateCompany(sendData, userRole)
				.then((res, err) => {
					const newData = res.data.response.company

					if (data.partner_company !== company.partner_company) {
						if (props.company.partner === data.partner_company) {
							addCompany({ company: data.company_name });
						} else if (props.company.partner !== data.partner_company) {
							delCompany({ company: data.company_name });
						}
					}

					setState({ ...state, company: newData, initialCompany: JSON.parse(JSON.stringify(newData)) });
					localStorage.setItem("edit_company_data", JSON.stringify({ company_name: newData.company_name, partner_company: newData.partner_company }));
					getData();

					if (company.active !== data.active) {
						let active;
						if (data.active) {
							active = 'enable';
						} else {
							active = 'disable'
						}

						disableCompany(userRole, sendData, active)
							.then((res, err) => {
								toggleLoader(false);
								const company = res.data.response.company;
								setState({ ...state, company: company, initialCompany: company });
							})
							.catch((error) => {
								toggleLoader(false);
								console.log('!disableCompany error', error.response);
								let errDescription = i18n.t('errorMessage.errDescription');
								if (error.response.data.response.error) {
									errDescription = error.response.data.response.error
								}
								toastr.error(errDescription)
							});
					}

					// updates company state of the company reducer and company_collection state of the partnerList reducer if changed the driver_recognition, geofencing_active values
					if (_.has(changedData, 'driver_recognition') || _.has(changedData, 'geofencing_active')) {
						if (props.company.company_id === company.id) {
							const updatedParams = {}
							if (_.has(changedData, 'driver_recognition')) {
								updatedParams.driver_recognition = changedData.driver_recognition
							}
							if (_.has(changedData, 'geofencing_active')) {
								updatedParams.company_data = { ...props.company.company_data, geofencing_active: changedData.geofencing_active }
							}
							editCompany(updatedParams)
						}

						const updatedParams = {}
						if (_.has(changedData, 'driver_recognition')) {
							updatedParams.driver_recognition = changedData.driver_recognition
						}
						if (_.has(changedData, 'geofencing_active')) {
							const obj = props.company_collection.find(({ id }) => id === company.id);
							updatedParams.company_data = { ...obj.company_data, geofencing_active: changedData.geofencing_active }
						}

						editCompanyCollection({
							id: company.id,
							...updatedParams
						})
					}

					toggleLoader(false);
					toastr.success("", t('updatedCompany'));
				})
				.catch((error) => {
					toggleLoader(false)
					console.error('!CompanyEditContainer updateCompany error: ', error.response, error)

					let errDescription = t('unableUpdateCompany');
					if (error.response.data.body) {
						errDescription = errorDetection(error.response.data.body) || error.response.data.body
					}
					toastr.error(errDescription);
				})
		}
	}

	const checkForm = (data) => {
		const emptyFields = ['trial_subscribers', 'company_phone_number', 'company_address2', 'custom_apn', 'external_srv_type'] // list of fields that can be empty
		let error = false;
		const { errMessage } = state;

		for (let i in data) {
			if (data[i] === '' && !emptyFields.includes(i)) {
				error = true;
				errMessage[i] = t('enterYour') + i.replaceAll('_', ' ') + '!';
			} else if (i === "company_phone_number" && data[i]?.length < 8) {
				error = true;
				errMessage.company_phone_number = i18n.t('errorMessage.errPhoneNumberLength');
			} else if (i === "company_phone_number" && data[i]?.length > 15) {
				error = true;
				errMessage.company_phone_number = i18n.t('errorMessage.errPhoneNumber');
			} else if (errMessage[i]) {
				errMessage[i] = null;
			}
		}

		if (data.geotab_email && !errMessage.geotab_email) {
			const re = /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(data.geotab_email)) {
				error = true;
				errMessage.geotab_email = t('errEmail');
			}
		}

		if (!errMessage.company_name && !/^[a-zA-Z0-9 \_\-\.]+$/.test(data.company_name)) {
			error = true;
			errMessage.company_name = t('errCompanyName');
		}

		setState({ ...state, errMessage });
		if (error) {
			toastr.error('', t('errCompanyValue'))
		}
		return error;
	}

	const handleInputChange = (event) => {
		const { target } = event;
		const { name } = target;
		let value = target.type === 'checkbox' ? target.checked : (name === 'company_phone_number') ? target.value.replace(/[^\d]/g, '') : target.value;
		let updatedData = state.data;

		if (name === 'download_files') {
			if (value) {
				value = 2 // all files
			} else {
				value = 1 // event files
			}
		}

		if (name === "company_country" && value !== "United States" && updatedData.company_state) {
			updatedData.company_state = "";
		}

		setState({ ...state, data: { ...updatedData, [name]: value } })
	}

	const handleNumericChange = (valint, valstr, e) => {
		const name = $(e).attr('name');
		const value = valint;

		setState({ ...state, data: { ...state.data, [name]: value } })
	}

	const handleSelectChange = (event) => {
		const { target } = event;
		const { name, type } = target;
		const value = type === 'checkbox' ? target.checked : target.value;

		setState({ ...state, data: { ...state.data, [name]: value } })
	}

	const handleDateChanged = (current) => {
		if (!moment(current, 'MM/DD/YYYY', true).isValid()) {
			toastr.error('', t('errValidDateValue'))
			return
		}

		setState({ ...state, data: { ...state.data, trial_date: moment(current).format('YYYYMMDD') } })
	}

	const formatTypes = (arr) => {
		const capitalized = arr.map(s => _.upperFirst(s));
		return capitalized.length > 1
			? capitalized.join(" & ")
			: capitalized[0] || "";
	};

	const modalConfirm = (e, action) => {
		let title, content;
		switch (action) {
			case 'delete_company':
				title = t('titleDeleteCompany')
				content = t('contentDeleteCompany', { company_name: state.company.company_name })
				break
			case 'delete_relation':
				const types = company.geotab_database ? 'geotab' : company.external_srv_type || company.external_srv_pending || '';
				const typesArray = types.split(',').filter(Boolean);
				if (company.bewhere_account_id) {
					typesArray.push('bewhere')
				}
				title = typesArray.length === 2 ? t('titleRemoveIntegrations', { types: formatTypes(typesArray)}) : t('titleRemoveIntegration', { type: formatTypes(typesArray) })
				content = typesArray.length === 2 ?
					t('contentRemoveRelations', { company_name: `"${location.state.company.company_name}"`, type1: _.upperFirst(typesArray[0]), type2: _.upperFirst(typesArray[1]) }) :
					t('contentRemoveRelation', { company_name: `"${location.state.company.company_name}"`, type: _.upperFirst(typesArray[0]) })
				break
			default:
				break
		}

		setState((prevState) => {
			return {
				...prevState, modal: { ...state.modal, show: true, title, content, type_action: action }, errMessage: { ...state.errMessage, user_login: '', user_password: '' }
			}
		});
	}

	const closeModal = () => {
		setState({ ...state, modal: { ...state.modal, error: false, show: false }, log_in: { user_login: '', user_password: '', fleet_token_r1: '' }, errMessage: { ...errMessage, geotab_email: '' } });
	}

	const deleteCompanyModal = () => {
		const { delCompany } = props
		const data = {
			company_name: state.company.company_name,
			partner_name: state.company.owner_company,
			user_role: userRole,
		}

		deleteCompany(data)
			.then((res, err) => {
				if (res.status === 200) {
					setState({ ...state, modal: { ...state.modal, show: false } });
					toastr.success('', t('companyDeleted'));

					if (data.partner_name === props.company.partner) {
						delCompany({ company: data.company_name });
					}

					navigate('/company');
				}
			})
			.catch((error) => {
				setState({ ...state, modal: { ...state.modal, show: false } });
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			});
	}

	const deleteGeotabRelationModal = async () => {
		const data = {
			company_name: state.company.company_name,
			partner_name: location.state.company.owner_company,
			user_role: user.roles[0],
			company_id: state.company.id,
			get_p: true,
		}

		const delGeotabCompany = (data) => {
			// DELETE GEOTAB RELATIONS (RoscoLive-side; independent of whether Geotab itself still has a record)
			return deleteGeotabCompany(data)
				.then((res, err) => {
					console.log('!deleteGeotabCompany res:', res, err)

					if (err) {
						toggleLoader(false);
						console.log('!deleteGeotabCompany err', err);
						toastr.error(i18n.t('errorMessage.errDescription'));
						return
					}

					toggleLoader(false);
					setState({ ...state, modal: { ...state.modal, show: false } });
					toastr.success('', t('relationDeleted', { type: 'Geotab' }))
				})
				.catch((error) => {
					toggleLoader(false);
					const err = _.get(error, 'response.data.response.error');
					console.log('!error', err, error?.response);

					setState({ ...state, modal: { ...state.modal, show: false } });
					toastr.error(err || i18n.t('errorMessage.errDescription'));
				});
		}

		let resGeotab;
		try {
			resGeotab = await getCompanyGeotabData(data);
		} catch (error) {
			console.log('!getCompanyGeotabData error status: ', error?.response?.status);
			resGeotab = null;
		}

		const geotab_company = resGeotab?.status === 200 ? resGeotab?.data?.response : null;

		if (!geotab_company || !geotab_company.database) {
			// Could not get usable Geotab credentials for this company - request failed, returned a
			// non-200, or came back with an empty/incomplete body. Either way we can't authenticate to
			// clean up the Geotab-side AddIn/notification templates, so just warn that the Geotab side
			// wasn't touched and remove the RoscoLive-side relation. Mirrors the resultAuth.error branch below.
			toggleLoader(false);
			toastr.warning(t('errRemoveGeotabDatabase'));
			return delGeotabCompany(data);
		}

		// REMOVES GEOTAB ADDINs
		// FWSD-4475
		let initData = {
			company_id: state.company.id,
			password: geotab_company.password,
			path: geotab_company.path,
			fleet_token: geotab_company.token,
			database: geotab_company.database,
			email: geotab_company.email,
			sessionId: geotab_company.session_id,
		}

		const resultAuth = await geotabAuthentication(initData)

		if (resultAuth.error) {
			toggleLoader(false);
			toastr.warning(t('errRemoveGeotabDatabase'));
			return delGeotabCompany(data);
		}
		const { geotabApi, geotabData } = resultAuth
		data.path = geotabData.path
		data.database = geotabData.database
		data.sessionId = geotabData.sessionId
		data.email = geotabData.email

		return new Promise((resolve, reject) => {
			const fail = (err) => {
				toggleLoader(false);
				console.log('!Geotab teardown error:', err);
				reject(err);
			};

			geotabApi.multiCall([
				['Get', {
					typeName: 'AddIn',
				}],
				['GetNotificationWebRequestTemplates', {
					credentials: {
						database: data.database,
						userName: data.email,
						sessionId: data.sessionId,
					}
				}],
			],
			(resCall) => {
				try {
					const addinsList = resCall[0]
					const notificationWebRequests = resCall[1]

					let notif_snapshot_exist_id = false;
					let notif_video_exist_id = false;
					let notif_snapshot_and_video_exist_id = false;
					let rosco_add_in_id = false;
					const multicalls = [];

					addinsList.forEach((addin, i) => {
						if (addin?.configuration?.name === 'Dual-Vision Video Camera' && rosco_add_in_id === false) {
							rosco_add_in_id = addin?.id
						}
					})

					notificationWebRequests.map((notification, i) => {
						if (notification.name == 'Auto-upload snapshot to RoscoLive' && !notif_snapshot_exist_id) {
							notif_snapshot_exist_id = notification.id;
						}
						else if (notification.name == 'Auto-upload video to RoscoLive' && !notif_video_exist_id) {
							notif_video_exist_id = notification.id;
						}
						else if (notification.name == 'Auto-upload snapshot and video clip to RoscoLive' && !notif_snapshot_and_video_exist_id) {
							notif_snapshot_and_video_exist_id = notification.id;
						}
					})

					if (rosco_add_in_id) {
						multicalls.push(
							['Remove', {
								typeName: 'AddIn',
								entity: { id: rosco_add_in_id },
								credentials: {
									database: data.database,
									userName: data.email,
									sessionId: data.sessionId,
								}
							}]
						)
					}

					if (notif_snapshot_exist_id) {
						multicalls.push(
							['Remove', {
								typeName: 'NotificationBinaryFile',
								entity: { id: notif_snapshot_exist_id },
								credentials: {
									database: data.database,
									userName: data.email,
									sessionId: data.sessionId,
								}
							}]
						)
					}

					if (notif_video_exist_id) {
						multicalls.push(
							['Remove', {
								typeName: 'NotificationBinaryFile',
								entity: { id: notif_video_exist_id },
								credentials: {
									database: data.database,
									userName: data.email,
									sessionId: data.sessionId,
								}
							}]
						)
					}

					if (notif_snapshot_and_video_exist_id) {
						multicalls.push(
							['Remove', {
								typeName: 'NotificationBinaryFile',
								entity: { id: notif_snapshot_and_video_exist_id },
								credentials: {
									database: data.database,
									userName: data.email,
									sessionId: data.sessionId,
								}
							}]
						)
					}

					if (!multicalls.length) {
						resolve(delGeotabCompany(data));
						return;
					}

					geotabApi.multiCall(
						multicalls,
						(resDel) => {
							resolve(delGeotabCompany(data));
						},
						fail
					);
				} catch (err) {
					fail(err);
				}
			},
			fail)
		});
	}

	const deleteExternalRelationModal = async () => {
		return await deleteExternalRelation({ externalType: externalType.toLowerCase(), company_id: state.company.id })
			.then(() => {
				toggleLoader(false);
				setState({ ...state, modal: { ...state.modal, show: false } })
				toastr.success('', t('relationDeleted', { type: externalType }))
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!deleteWebfleetRelationModal error:', error.response, error)
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			})
	}

	const importStatus = () => {
		const { initialCompany } = state;
		const { token } = initialCompany;
		toggleLoader(true)
		checkImportStatus(token)
			.then((res, err) => {
				const { status } = res.data.response;
				setState(prevState => ({ ...prevState, status: status }));
				toggleLoader(false);
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!importStatus error: ', error);
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			});
	}
	const {
		company_name,
		company_city,
		company_state,
		company_zipcode,
		company_address,
		company_country,
		partner_company,
		file_retention_time,
		reformat_reminder,
		industry_type,
		company_phone_number,
	} = errMessage;

	const { trial_status, trial_date, trial_subscribers } = data;

	const industryTypeDisplayOptions = [
		i18n.t('companiesPage.industryTypes.FTL/LTL/Courier'),
		i18n.t('companiesPage.industryTypes.Medical/Health'),
		i18n.t('companiesPage.industryTypes.School/Education'),
		i18n.t('companiesPage.industryTypes.Construction'),
		i18n.t('companiesPage.industryTypes.Waste Management'),
		i18n.t('companiesPage.industryTypes.Mass Transit'),
		i18n.t('companiesPage.industryTypes.Agricultural'),
		i18n.t('companiesPage.industryTypes.Government'),
		i18n.t('companiesPage.industryTypes.Industrial'),
		i18n.t('companiesPage.industryTypes.Other')
	];

	const industryTypeValueOptions = [
		'ftl_ltl_courier',
		'medical_health',
		'school_education',
		'construction',
		'waste_management',
		'mass_transit',
		'agricultural',
		'government',
		'industrial',
		'other'
	];

	const companyList = () => {
		const option = []
		if (companies) {
			companies.map((elem, index) => {
				option[index] = (<option key={elem} value={elem}>{elem}</option>)
			})
		}
		return (
			<select
				placeholder="select"
				type="text"
				className="rosco-select block"
				name="partner_company"
				id="partner_company"
				value={data.partner_company}
				onChange={handleSelectChange}
			>
				<option disabled value />
				{option}
			</select>
		)
	};

	const isDayDisabled = (current) => {
		return !moment(current).isAfter(moment())
	}

	const deleteBeWhereRelation = async () => {
		const data = {
			company: company,
			data: {
				bewhere_account_id: null,
			}
		};
		return await updateCompany(data, userRole).then(() => {
			toastr.success("", t('relationDeleted', { type: 'BeWhere' }));
			toggleLoader(false);
			setState({ ...state, modal: { ...state.modal, show: false } })
		}).catch((error) => {
			toggleLoader(false);
			console.log("BeWhere update error", error);
			toastr.error(t('beWhereRelationDeleteError'))
		})
	}

	const onDeleteModalClick = async () => {
		try {
			toggleLoader(true);

			if (modal.type_action === 'delete_company') {
				await deleteCompanyModal();
			} else if (modal.type_action === 'delete_relation') {
				const promises = [];

				if (company.bewhere_account_id) {
					promises.push(deleteBeWhereRelation());
				}

				if (externalType === 'Geotab') {
					promises.push(deleteGeotabRelationModal());
				} else if (externalType) {
					promises.push(deleteExternalRelationModal());
				}

				await Promise.all(promises);
				await getData();
			}
		} catch (error) {
			console.error('onDeleteModalClick error:', error);
			// Close the confirmation modal on any failure path too - otherwise it stays open over
			// data that getData() is about to refresh underneath it, and the user can click Delete again.
			setState((prev) => ({ ...prev, modal: { ...prev.modal, show: false } }));
			toastr.error(i18n.t('errorMessage.errDescription'));
			// Some relations may have been deleted before the failure; refresh so the UI reflects actual state.
			await getData().catch(() => {});
		} finally {
			toggleLoader(false);
		}
	}

	if (!company) {
		return (
			<GreyHeader title={t('titleEditCompany')} hideSubtitle />
		)
	}

	return (
		<div>
			<GreyHeader
				title={t('titleEditCompany')}
				subtitle={initialCompany.company_name}
			/>

			<div className="page-subheader">

				<div className="subheader-section company-info">
					{!hideProvisionBtns &&
						<>
							<CompanyExternalIntegrations
								company={company}
								modalConfirm={modalConfirm}
								getCompany={getData}
								deleteExternalRelationModal={deleteExternalRelationModal}
								deleteGeotabRelationModal={deleteGeotabRelationModal}
							/>
						</>
					}
				</div>

				<div className="subheader-section">
					{(userRole === 'partner' || isInternalUser(userRole)) && (
						<CustomButton variant="secondary" disabled={!state.allow_edit_company} onClick={sendForm}>
							{t('btnSave')}
						</CustomButton>
					)}
					<CustomButton variant="secondary-outline" onClick={goBack}>{t('btnBack')}</CustomButton>
					{isInternalUser(userRole) && state.allow_edit_company &&
						<CustomButton variant="delete" onClick={(e) => modalConfirm(e, 'delete_company')}>{t('btnDelete')}</CustomButton>
					}
				</div>
			</div>

			<main className='main-content-block'>
				<form>
					<section>
						<h3 className="category-title">{t('titleCompanyInfo')}</h3>
						<div className="two-column-grid">
							<div className={classnames('two-columns', { 'has-error': company_name })}>
								<label className="control-label">{t('labelName')}</label>
								<input
									type="text"
									name="company_name"
									className="vehicle-search"
									onChange={(e) => { handleInputChange(e) }}
									value={data.company_name || ""}
									maxLength={50}
								/>
								{company_name && <span className="help-block">{company_name}</span>}
							</div>

							<div className={classnames({ 'has-error': company_address })}>
								<label className="control-label">{t('labelAddress')}</label>
								<input type="text" name="company_address" className="vehicle-search" onChange={handleInputChange} value={data.company_address || ""} />
								{company_address && <span className="help-block">{company_address}</span>}
							</div>

							<div className="optional">
								<label className="control-label">{t('labelAddress2')} <span>{t('optional')}</span></label>
								<input type="text" name="company_address2" className="vehicle-search" onChange={handleInputChange} value={data.company_address2 || ""} />
							</div>

							<div className={classnames({ 'has-error': company_city })}>
								<label className="control-label">{t('labelCity')}</label>
								<input type="text" name="company_city" className="vehicle-search" onChange={handleInputChange} value={data.company_city || ""} />
								{company_city && <span className="help-block">{company_city}</span>}
							</div>

							<div className={classnames({ 'has-error': company_state })}>
								<label className="control-label">{t('labelState')}</label>
								{data.company_country === "United States" ?
									<select
										placeholder="select"
										className="rosco-select block"
										name="company_state"
										onChange={handleInputChange}
										value={data.company_state}
									>
										{!statesOptions.includes(data.company_state) && <option value={data.company_state}>{data.company_state}</option>}
										{statesOptions.map(value => (
											<option key={value} value={value}>{value}</option>
										))}
									</select> :
									<input type="text" name="company_state" className="vehicle-search" onChange={handleInputChange} value={data.company_state || ""} />}
								{company_state && <span className="help-block">{company_state}</span>}
							</div>

							<div className={classnames({ 'has-error': company_zipcode })}>
								<label className="control-label">{t('labelZipCode')}</label>
								<input type="text" name="company_zipcode" className="vehicle-search" onChange={handleInputChange} value={data.company_zipcode || ""} />
								{company_zipcode && <span className="help-block">{company_zipcode}</span>}
							</div>

							<div className={classnames({ 'has-error': company_country })}>
								<label className="control-label">{t('labelCountry')}</label>
								<select
									placeholder="select"
									className="rosco-select block"
									name="company_country"
									onChange={handleInputChange}
									value={data.company_country}
								>
									{!allCountriesOptions.includes(data.company_country) && <option value={data.company_country}>{data.company_country}</option>}
									{allCountriesOptions.map(value => (
										<option key={value} value={value}>{value}</option>
									))}
								</select>
								{company_country && <span className="help-block">{company_country}</span>}
							</div>

							<div className={classnames("optional", { 'has-error': company_phone_number })}>
								<label className="control-label">{t('labelPhoneNumber')} <span>{t('optional')}</span></label>
								<input
									type="text"
									name="company_phone_number"
									className="vehicle-search"
									onChange={handleInputChange}
									value={data.company_phone_number || ""}
								/>
								{company_phone_number && <span className="help-block">{company_phone_number}</span>}
							</div>

							<div className={classnames({ 'has-error': industry_type })}>
								<label className="control-label">{t('labelIndustryType')}</label>
								<select
									placeholder="select"
									className="rosco-select block"
									name="industry_type"
									id="industry_type"
									onChange={(e) => { handleInputChange(e) }}
									value={data.industry_type ? data.industry_type : ''}
								>
									<option value="" />
									{industryTypeDisplayOptions.map((item, i) => (
										<option key={i} value={industryTypeValueOptions[i]}>{item}</option>
									))}
								</select>
								{industry_type && <span className="help-block">{industry_type}</span>}
							</div>
						</div>
					</section>

					{isInternalUser(userRole) && (
						<section>
							<h3 className="category-title">{t('labelAdminTools')}</h3>
							<div className="two-column-grid">

								<div className={classnames({ 'has-error': partner_company })}>
									<label htmlFor="partner_company" className="control-label">{t('labelPartnerName')}</label>
									{companyList()}
									{partner_company && <span className="help-block">{partner_company}</span>}
								</div>

								<div className={classnames({ 'has-error': reformat_reminder })}>
									<label className="control-label">{t('SDCardReformatReminder')}</label>
									<select
										placeholder="select"
										className="rosco-select block"
										name="reformat_reminder"
										id="reformat_reminder"
										onChange={handleInputChange}
										value={data.reformat_reminder ? data.reformat_reminder : ''}
									>
										<option value="0">{t('noReminder')}</option>
										<option value="1">{t('1month')}</option>
										{_.range(2, 12).map(item => <option value={item} key={item}>{`${item} ${t('months')}`}</option>)}
									</select>
									{reformat_reminder && <span className="help-block">{reformat_reminder}</span>}
								</div>

								<div>
									<label htmlFor="timezone" className="control-label">{t('labelTimeZone')}</label>
									<select
										placeholder="select"
										className="rosco-select block"
										name="timezone"
										id="timezone"
										value={data.timezone || 'US/Eastern'}
										onChange={handleInputChange}
									>
										{timezoneDBOptions()}
									</select>
								</div>

								{(data.partner_company === 'Rosco Vision WCS' || initialCompany.company_type === 'WCS')
									&& (
										<div className='toggles-container'>
											<div className={classnames('toggle-wrapper', { 'has-error': file_retention_time })}>
												<label>{t('labelFileRetention')}</label>
												<div>
													<NumericInput
														step={1}
														min={1}
														max={24}
														precision={0}
														maxLength={2}
														size={2}
														className="rosco-select"
														name="file_retention_time"
														value={data.file_retention_time}
														onChange={handleNumericChange}
													/>
												</div>
												{file_retention_time && <span className="help-block">{file_retention_time}</span>}
											</div>
											{userRole === 'system_admin'
												&& (
													<label className='toggle-wrapper'>
														<span className="toggle-left-title">{t('labelDownloadEventFiles')}</span>
														<div>
															<Toggle
																name="download_files"
																icons={false}
																checked={data.download_files === '2'}
																onChange={handleInputChange}
															/>
															<span>{t('labelAllFiles')}</span>
														</div>
													</label>
												)}
										</div>
									)}

								<div>
									<label htmlFor="active" className="control-label">{t('labelEnableDriverID')}</label>
									<select
										placeholder="select"
										className="rosco-select block"
										name="driver_recognition"
										id="driver_recognition"
										onChange={handleInputChange}
										value={data.driver_recognition}
									>
										<option value="manual">{t('optionManual')}</option>
										<option value="cardreader">{t('optionCardReader')}</option>
										<option value="faceid">{t('optionFaceID')}</option>
									</select>
								</div>

								<div>
									<EventVideoExpiration
										companyId={state.company.id}
										value={data.event_expiration}
										onChange={(value) => { setState({ ...state, data: { ...state.data, event_expiration: value } }) }}
									/>

									<div className="company-paid-add-ons">
										<h4 className="category-title">{t('labelPaidAddons')}:</h4>
										<div className="description">{t('descriptionPaidAddons')}</div>
										<div className="toggle-wrapper">
											<label>
												<span className="toggle-left-title">{t('labelZonesFeature')}</span>
												<Toggle
													name="advanced_profile_settings"
													checked={data.geofencing_active || false}
													onChange={() => setShowZonesConfirmation(true)}
												/>
											</label>
										</div>
										{!_.isEmpty(data.geofencing_last_updated) &&
											<div className="description">
												Last updated
												{data.geofencing_last_updated.updated_by &&
													<> by <span className="toggle_updated_by">{_.startCase(data.geofencing_last_updated.updated_by)}</span></>
												}
												{data.geofencing_last_updated.updated_at &&
													<> on {moment(data.geofencing_last_updated.updated_at).format("MMM DD, YYYY")}</>
												}
											</div>
											// <div>{`Last updated by ${data.geofencing_last_updated.updated_by} on Mar 5, 2026`}</div>
										}
									</div>
								</div>

								{isInternalUser(userRole) &&
									<CustomAPN
										custom_apn={data.custom_apn || ''}
										onUpdateApn={(e, value) => setState({ ...state, data: { ...state.data, custom_apn: value } })}
									/>
								}
							</div>

							<div className="company-trial-wrapper">
								<hr />
								<div className="two-column-grid margin-top">

									<div className="toggle-date-wrapper">
										<div className="toggle-label">
											<label>
												<span className="toggle-left-title">{t('labelTrialCompany')}</span>
												<Toggle
													name="trial_status"
													checked={trial_status || false}
													onChange={handleInputChange}
												/>
											</label>
										</div>
										{trial_status
											&& (
												<div>
													<label htmlFor="trial_date">{t('labelTrialEndDate')}</label>
													<CalendarDropdown
														date={moment(trial_date)}
														disabledDay={isDayDisabled}
														onChange={handleDateChanged}
													/>
												</div>
											)}
									</div>
									{trial_status
										&& (
											<div>
												<label htmlFor="trial_subscribers">{t('labelTrialSubscribers')}</label>
												<Select
													isMulti={true}
													name="trial_subscribers"
													options={trialAvailableUsers}
													id="trial_subscribers"
													onChange={(value) => setState({ ...state, data: { ...data, trial_subscribers: value.map(i => i = i.value).sort().join(",") } })}
													placeholder={t('placeholderSelectSubscriber')}
													className="rosco-select"
													value={trial_subscribers ? trial_subscribers.split(",").map(i => { if (!!i) return i = { value: i, label: i } }) : ""}
												/>
											</div>
										)}
								</div>
							</div>

							<div className='company-toggles-wrapper'>
								<div className='toggle-wrapper'>
									<label>
										<span className="toggle-left-title">{t('labelAdvancedProfileSettings')}</span>
										<Toggle
											name="advanced_profile_settings"
											checked={data.advanced_profile_settings || false}
											onChange={handleInputChange}
										/>
									</label>
								</div>
								<div className="toggle-wrapper">
									<label>
										<span className="toggle-left-title">{t('labelEnable/DisableCompany')}</span>
										<Toggle
											name="active"
											checked={data.active ? data.active : false}
											onChange={handleInputChange}
										/>
									</label>
								</div>
								{userRole === 'system_admin'
									&& (
										<div className='toggle-wrapper'>
											<label>
												<span className="toggle-left-title">{t('labelAssetDeletionProtection')}</span>
												<Toggle
													name="asset_deletion_protection"
													checked={data.asset_deletion_protection ? data.asset_deletion_protection : false}
													onChange={handleInputChange}
												/>
											</label>
										</div>
									)}
								<div className='toggle-wrapper'>
									<label>
										<span className="toggle-left-title">{t('labelUsingRoscoSIM')}</span>
										<Toggle
											name="using_rosco_sim"
											checked={data.using_rosco_sim || false}
											onChange={handleInputChange}
										/>
									</label>
								</div>
								<div className='toggle-wrapper'>
									<label>
										<span className="toggle-left-title">{t('labelOverrideOverageLimits')}</span>
										<Toggle
											name="override_overage_limits"
											checked={data.override_overage_limits || false}
											onChange={handleInputChange}
										/>
									</label>
								</div>
								{/* FWSD-8270, Hide the SpeedLimit feature (and toggle to enable this feature) from Geotab related companies and all of Tenna companies */}
								{['system_admin', 'customer_service'].includes(userRole) && (
									<div className='toggle-wrapper'>
										<label>
											<span className="toggle-left-title">{t('labelSpeedLimits')}</span>
											<Toggle
												name="speedlimit_feature"
												checked={data.speedlimit_feature || false}
												onChange={handleInputChange}
											/>
										</label>
									</div>
								)}
							</div>
						</section>
					)}
				</form>
			</main>

			<Modal
				show={modal.show}
				onHide={closeModal}
				className="modal-lg-size"
			>
				<Modal.Header closeButton>
					<Modal.Title className={`${modal.type_action === 'delete_company' && 'delete-title'}`}>{modal.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{modal.type_action === 'delete_company' && <div className='modal-text'>{modal.content}</div>}
					{['delete_relation'].includes(modal.type_action) && <div>{modal.content}</div>}
				</Modal.Body>
				<Modal.Footer bsPrefix="default-modal-footer modal-footer">
					<CustomButton variant="delete" onClick={onDeleteModalClick}>{t('btnModalDelete')}</CustomButton>
				</Modal.Footer>
			</Modal>

			{showZonesConfirmation &&
				<ModalDelete
					title={data.geofencing_active ? t('titleDisableZonesFeature') : t('titleEnableZonesFeature')}
					content={data.geofencing_active ? t('contentDisableZonesFeature') : t('contentEnableZonesFeature')}
					styleView="primary"
					backdropClassName="upper"
					dialogClassName="text-center"
					showClose
					deleteBtnName={t('btnModalConfirm')}
					closeBtnName={t('btnModalCancel')}
					closeModal={() => setShowZonesConfirmation(false)}
					deleteModal={() => {
						setState({ ...state, data: { ...state.data, geofencing_active: !data.geofencing_active } })
						setShowZonesConfirmation(false)
					}}
				/>
			}
		</div>
	)
}

CompanyEditContainer.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
		company_collection: state.partnerList.company_collection,
	}),
	dispatch => ({
		delCompany: (company) => {
			dispatch({ type: 'DEL_COMPANY_SUCCESS', payload: company });
		},
		addCompany: (company) => {
			dispatch({ type: 'ADD_COMPANY_SUCCESS', payload: company });
		},
		editCompany: data => dispatch({ type: 'EDIT_COMPANY', payload: data }),
		editCompanyCollection: data => dispatch({ type: 'EDIT_COMPANY_COLLECTION', payload: data }),
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		},
	}),
)(CompanyEditContainer);
